/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import { Flex, Heading, Text, Box } from '@theme-ui/components';
import StyledBackgroundSection from '../../molecules/BackgroundSection';

const BannerText = ({ title, description }) => (
  <Flex sx={textContainerStyle}>
    <Heading as="h1" sx={headingStyle}>
      {title}
    </Heading>
    <Text sx={subtitleStyle}>
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </Text>
  </Flex>
);

const HeadBanner = ({
  image,
  title,
  description,
  bannerStyle,
  minWidth = ['100%', '450px', '450px', '850px'],
  minHeight = ['315px', '270px'],
  ml,
}) => (
  <Box sx={bannerStyle}>
    {image ? (
      <StyledBackgroundSection
        minWidth={minWidth}
        minHeight={minHeight}
        image={image}
        className="bannerImg">
        <Box sx={{ ml, mr: [1, 2, 3] }}>
          <BannerText title={title} description={description} />
        </Box>
      </StyledBackgroundSection>
    ) : (
      <Box sx={{ minHeight }}>
        <Box
          sx={{
            ml: [1, 4, 5, 6],
            mr: [1, 2, 3],
            textAlign: ['center', 'left'],
          }}>
          <BannerText />
        </Box>
      </Box>
    )}
  </Box>
);

const textContainerStyle = {
  flexDirection: 'column',
  alignItems: ['center', 'center', 'flex-start', 'flex-start'],
  justifyContent: 'center',
  textAlign: ['center', 'center', 'left', 'left'],
  height: '100%',
  color: 'white',
};

const headingStyle = {
  fontSize: ['1.75rem', '1.625rem', '1.625rem', 5],
  lineHeight: ['36.62px', '41.86px'],
  fontWeight: 'bold',
};

const subtitleStyle = {
  fontSize: ['1rem', '1.125rem'],
  lineHeight: ['20.93px', '23.54px'],
};

export default HeadBanner;
